/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptanceDeadline
 */
export interface AcceptanceDeadline {
}

/**
 * Check if a given object implements the AcceptanceDeadline interface.
 */
export function instanceOfAcceptanceDeadline(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AcceptanceDeadlineFromJSON(json: any): AcceptanceDeadline {
    return AcceptanceDeadlineFromJSONTyped(json, false);
}

export function AcceptanceDeadlineFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptanceDeadline {
    return json;
}

export function AcceptanceDeadlineToJSON(value?: AcceptanceDeadline | null): any {
    return value;
}

